export const formatPercent = (value, digits = 2) => {
    if (typeof value !== 'number') return 'N/A';
    return `${(value * 100).toFixed(digits)}%`;
};

export const formatPeriodDisplay = (startDateStr, endDateStr) => {
    if (!startDateStr || !endDateStr) return 'N/A';
    const start = new Date(startDateStr);
    const end = new Date(endDateStr);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
        return 'Invalid Date Range';
    }
    const startMonth = start.getMonth();
    const startDateNum = start.getDate();
    const startYear = start.getFullYear();
    const endMonth = end.getMonth();
    const endDateNum = end.getDate();
    const endYear = end.getFullYear();
    if (
        startMonth === 0 &&
        startDateNum === 1 &&
        endMonth === 11 &&
        endDateNum === 31 &&
        startYear === endYear
    ) {
        return startYear.toString();
    } else {
        return `${startDateStr} - ${endDateStr}`;
    }
};